import type { Category } from "./types";

export const categories: Category[] = [
  {
    key: "ethics-drama",
    name: "伦理剧情",
    en: "Drama",
    desc: "以人性抉择为轴心的主线伦理叙事",
    longDesc:
      "聚焦家庭、职场与亲密关系中的道德边界，用细腻的长镜头与克制的对白，把「该不该」变成「为什么」。适合愿意慢慢咀嚼人物动机的观众。",
    icon: "ri-book-open-line",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20Japanese%20woman%20in%20a%20dark%20navy%20trench%20coat%20standing%20in%20a%20quiet%20corridor%20with%20soft%20window%20light%2C%20muted%20grey%20background%2C%20cinematic%20moody%20lighting%2C%20film%20grain%2C%20subtle%20orange%20accent%20reflection&width=800&height=1000&seq=cat-ethics-drama-01&orientation=portrait",
  },
  {
    key: "ethics-family",
    name: "伦理家庭",
    en: "Family",
    desc: "代际关系与家庭秘密的多视角展开",
    longDesc:
      "从餐桌、玄关到家族老宅，家庭是最小的伦理战场。这里收录关于赡养、继承、血缘与养育之恩的作品，常以群像方式呈现每个人的难处。",
    icon: "ri-home-heart-line",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20traditional%20family%20dining%20room%20at%20dusk%20with%20low%20wooden%20table%20and%20paper%20lantern%20glow%2C%20empty%20chairs%2C%20warm%20amber%20light%20against%20cool%20grey%20walls%2C%20cinematic%20still%20life%2C%20muted%20editorial%20tone&width=800&height=1000&seq=cat-ethics-family-02&orientation=portrait",
  },
  {
    key: "ethics-love",
    name: "伦理爱情",
    en: "Romance",
    desc: "越界与克制之间的情感较量",
    longDesc:
      "不伦、禁忌、未完成的爱。这些作品并不为越界辩护，而是把镜头对准心动发生的那一秒，以及此后漫长而艰难的承担。",
    icon: "ri-heart-3-line",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20silhouettes%20of%20a%20man%20and%20woman%20standing%20apart%20in%20a%20rainy%20Tokyo%20alley%20at%20night%2C%20neon%20reflections%20in%20puddles%2C%20muted%20teal%20and%20warm%20orange%20tones%2C%20cinematic%20anamorphic%20photography&width=800&height=1000&seq=cat-ethics-love-03&orientation=portrait",
  },
  {
    key: "ethics-workplace",
    name: "伦理职场",
    en: "Workplace",
    desc: "组织压力下的良知与妥协",
    longDesc:
      "会议室里的沉默也是台词。从医疗、法律到新闻现场，这些剧集讨论职业伦理、举报与同谋，把制度的重量落在具体的人身上。",
    icon: "ri-briefcase-line",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20Japanese%20corporate%20meeting%20room%20with%20long%20glass%20table%20and%20city%20view%20at%20blue%20hour%2C%20deep%20navy%20grey%20tones%2C%20single%20warm%20desk%20lamp%2C%20architectural%20editorial%20photography%2C%20cinematic%20shadow&width=800&height=1000&seq=cat-ethics-workplace-04&orientation=portrait",
  },
  {
    key: "era-showa",
    name: "年代昭和",
    en: "Showa Era",
    desc: "昭和背景下的社会变迁与个人命运",
    longDesc:
      "从战后复苏到泡沫前夜，昭和是日本伦理叙事最厚重的背景板。老式电话、团地住宅与黑白电视，把个人选择放进时代的洪流里。",
    icon: "ri-film-line",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Showa%20era%20Japanese%20street%20scene%20with%20old%20wooden%20shopfronts%20and%20hanging%20incandescent%20signs%2C%20evening%20warm%20amber%20light%2C%20film%20photograph%20grain%2C%20muted%20brown%20and%20grey%20palette&width=800&height=1000&seq=cat-era-showa-05&orientation=portrait",
  },
  {
    key: "era-modern",
    name: "当代都市",
    en: "Modern City",
    desc: "平成到令和的都市孤独与共生",
    longDesc:
      "共享公寓、外卖平台、社交媒体。当代作品把伦理问题放进算法与租金里，讲的是我们这代人如何在拥挤的城市里彼此靠近又互相责备。",
    icon: "ri-building-4-line",
    cover:
      "https://readdy.ai/api/search-image?query=Tokyo%20apartment%20balcony%20at%20rainy%20night%20with%20warm%20window%20light%20and%20distant%20city%20towers%2C%20wet%20railing%2C%20reflective%20moody%20atmosphere%2C%20muted%20navy%20and%20amber%20cinematic%20tones&width=800&height=1000&seq=cat-era-modern-06&orientation=portrait",
  },
];

export const regions = ["日本", "日本 / 合拍"];